(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastra-collection-rail')) {
    customElements.define('vastra-collection-rail', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.vcc__track');
        const controls = this.querySelector('.vcc__controls');
        const buttons = [...this.querySelectorAll('[data-step]')];
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          controls.hidden = maximum < 2;
          buttons.forEach(button => { button.disabled = Number(button.dataset.step) < 0 ? Math.abs(track.scrollLeft) <= 2 : Math.abs(track.scrollLeft) >= maximum - 2; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.step) * track.clientWidth * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastra-hero')) {
    customElements.define('vastra-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        clearInterval(this.timer);
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.vhero__track');
        this.slides = [...this.querySelectorAll('.vhero__slide')];
        this.index = 0;
        this.trackWidth = this.track.clientWidth;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        const move = (index) => {
          const count = this.slides.length;
          const destination = this.dataset.loop === 'true' ? (index + count) % count : Math.min(count - 1, Math.max(0, index));
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollTo({ left: destination * this.track.clientWidth * direction, behavior: this.motion.matches ? 'instant' : 'smooth' });
        };
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => move(this.index + Number(button.dataset.step)), { signal }));
        this.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.slide)), { signal }));
        const update = () => {
          this.index = Math.round(Math.abs(this.track.scrollLeft) / Math.max(1, this.trackWidth));
          this.slides.forEach((slide, index) => {
            slide.inert = index !== this.index;
            slide.setAttribute('aria-hidden', String(index !== this.index));
          });
          this.querySelectorAll('[data-slide]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.slide) === this.index)));
          this.querySelectorAll('[data-step]').forEach(button => { button.disabled = this.dataset.loop !== 'true' && (Number(button.dataset.step) < 0 ? this.index === 0 : this.index === this.slides.length - 1); });
        };
        this.track.addEventListener('scroll', update, { passive: true, signal });
        const pauseButton = this.querySelector('[data-pause]');
        const updatePause = () => {
          if (!pauseButton) return;
          pauseButton.setAttribute('aria-label', this.paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
          pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
        };
        pauseButton?.addEventListener('click', () => { this.paused = !this.paused; updatePause(); }, { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.paused = true; updatePause(); } }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.paused = true; updatePause(); move(index); }
        }, { signal });
        if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) move(this.index + 1);
          }, Math.max(2000, Number(this.dataset.delay) || 5000));
        }
        this.resize = new ResizeObserver(() => {
          const nextWidth = this.track.clientWidth;
          if (nextWidth === this.trackWidth) return;
          this.trackWidth = nextWidth;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollTo({ left: this.index * nextWidth * direction, behavior: 'instant' });
          update();
        });
        this.resize.observe(this.track);
        updatePause();
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastra-product-rail')) {
    customElements.define('vastra-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.vpr__track');
        if (!track) return;
        const buttons = [...this.querySelectorAll('[data-step]')];
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          buttons.forEach(button => { button.disabled = Number(button.dataset.step) < 0 ? position <= 2 : position >= maximum - 2; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.step) * track.clientWidth * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastra-video-stories')) {
    customElements.define('vastra-video-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.vstories__track');
        const controls = this.querySelector('.vstories__controls');
        if (!track) { if (controls) controls.hidden = true; return; }
        const buttons = [...this.querySelectorAll('[data-step]')];
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          controls.hidden = maximum < 2;
          buttons.forEach(button => { button.disabled = Number(button.dataset.step) < 0 ? Math.abs(track.scrollLeft) <= 2 : Math.abs(track.scrollLeft) >= maximum - 2; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.step) * track.clientWidth * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        this.addEventListener('play', event => {
          if (!(event.target instanceof HTMLVideoElement)) return;
          this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
        }, { capture: true, signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vastraanii-motion-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vastraanii-motion-edit')) {
    customElements.define('vastraanii-motion-edit', class extends HTMLElement {
      connectedCallback() {
        this.disconnect();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const track = this.querySelector('.vmotion__track');
        const controls = this.querySelector('.vmotion__controls');
        if (!track) return;
        const videos = [...this.querySelectorAll('video')];
        const buttons = [...this.querySelectorAll('[data-step]')];
        const pauseAll = except => videos.forEach(video => { if (video !== except) video.pause(); });
        videos.forEach(video => {
          const title = video.closest('.vmotion__card').querySelector('.vmotion__title');
          if (title) video.setAttribute('aria-labelledby', title.id);
          video.autoplay = false;
          video.addEventListener('play', () => pauseAll(video), { signal });
        });
        document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); }, { signal });
        this.visibility = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting || entry.intersectionRatio < .25) entry.target.pause(); });
        }, { threshold: [0, .25] });
        videos.forEach(video => this.visibility.observe(video));
        const updateControls = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          if (controls) controls.hidden = maximum < 2;
          buttons.forEach(button => { button.disabled = Number(button.dataset.step) < 0 ? position <= 2 : position >= maximum - 2; });
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const firstCard = track.firstElementChild;
          const step = firstCard ? firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.step) * step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        track.addEventListener('scroll', updateControls, { passive: true, signal });
        this.resize = new ResizeObserver(updateControls);
        this.resize.observe(track);
        updateControls();
      }
      disconnect() {
        this.abort?.abort();
        this.visibility?.disconnect();
        this.resize?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
      disconnectedCallback() { this.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
